import { Component} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { LocalStorageService} from '../shared/local-storage.service';
import { AlertService } from '../shared/alert/alert.service';
import { CancellationService } from './cancellation.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { IMyOptions } from 'ngx-mydatepicker';
import { ThirdParty } from '../entity/third-party';
import { Sample } from '../entity/sample';
import { ResultDu } from '../entity/result-du';
import { ProducerAutocompleteSearchResult } from '../shared/producers/producer-autocomplete-search-result';


@Component({
  selector: 'cancellation',
  templateUrl: './cancellation.component.html'
})
export class CancellationComponent {

  public takingDate: any;
  datePickerOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
    dayLabels: {su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam'},
    monthLabels: { 1: 'Janvier', 2: 'Fevrier', 3: 'Mars', 4: 'Avril', 5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Aout', 9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Decembre' },
    showTodayBtn: false,
    sunHighlight: false,
    alignSelectorRight: false
  };
  private step: number;
  private producers: ThirdParty[];
  private selectedProducer: ThirdParty;
  private samples: Sample[];
  private selectedResults: ResultDu[];
  private comment: string;
  private filename: string;
  private cancellableDus: string[];
  private allSelected: boolean[];
  private uploadingFile: boolean;
  producersList: ThirdParty[];
  producersListSearch: string;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private cancellationService: CancellationService,
      private spinnerService: SpinnerService,
      private localStorageService: LocalStorageService,
      private alertService: AlertService)
  {
    let today = new Date;
    this.takingDate = { date: { year: today.getFullYear(), month: today.getMonth()+1, day: today.getDate() } };
    this.producers = new Array();
    this.producersList = [];
    this.producersListSearch = null;
    this.samples = new Array();
    this.selectedProducer = null;
    this.selectedResults = new Array();
    this.cancellableDus = environment.cancellableDus;
    this.comment = "";
    this.filename = "";
    this.allSelected = new Array();
    this.uploadingFile = false;
    this.route.params.subscribe(
      params =>{
          this.step = parseInt(params['step']);
      }
    );

  }

  ngOnInit():void {
    if(this.step == 1){
      this.clearAll();
    }
    this.loadAll();
  }


  ngDoCheck(): void {
    if (this.step == 3) {
      this.samples = this.route.snapshot.data['data'];
    }
  }

  public goToStep(event: any, step: number): void
  {
    event.preventDefault();
    if(step < this.step){
      this.updateStep(step);
    }
  }

  public back(event: any): void
  {
    event.preventDefault();
    this.prevStep();
  }


  public next(event: any): void
  {
    event.preventDefault();
    this.nextStep();
  }

  private nextStep(): void
  {
    let step = this.step + 1 ;
    this.updateStep(step);
  }

  private prevStep(): void
  {
    if (this.step>1) {
      let step = this.step - 1 ;
      this.updateStep(step);
    }
  }

  private updateStep(step): void
  {
    this.saveAll();
    let routeData = {};
    if(step == 2){
      routeData['producerSiret'] = this.selectedProducer.siret;
    }
    if(step == 3){
      routeData['takingDate'] = this.takingDate.date;
      routeData['producerSiret'] = this.selectedProducer.siret;
    }
    if(step == 4){
      routeData['takingDate'] = this.takingDate.date;
      routeData['producerSiret'] = this.selectedProducer.siret;
    }
    localStorage.setItem('routeData', JSON.stringify(routeData));
    this.router.navigate(['cancellation/'+step]);
  }



  public displayPrev(): boolean
  {
    let display = false;
    switch (this.step) {
      case 2 :
        display = true;
        break;
      case 3 :
        display = true;
        break;
      case 4 :
        display = true;
        break;
      case 5 :
            display = true;
            break;
      default:
        display = false;
    }
    return display;
  }

  public displayNext(): boolean
  {
    let display = false;
    switch (this.step) {
      case 1 :
        display = true;
        break;
      case 2 :
        display = true;
        break;
      case 3 :
        display = true;
        break;
      case 4 :
        display = true;
        break;
      default:
        display = false;
    }
    return display;
  }

  public stepIsValid(): boolean
  {
    let valid = false;
    switch (this.step) {
      case 1:
        valid = this.selectedProducer != null;
        break;
      case 2 :
        valid = true;
        break;
      case 3 :
        valid = this.selectedResults.length > 0;
        break;
      case 4 :
        valid = !this.uploadingFile && this.comment.trim().length > 0;
        break;
      case 5:
        valid = true;
        break;
      default:
        valid = false;
    }
    return valid;
  }
  public selectProducer(data: ProducerAutocompleteSearchResult): void
  {
    const producer = data.selectedProducer;
    const producers = data.fetchedProducers;
    const search = data.search;
    this.selectedResults = new Array();
    this.selectedProducer = producer;
    this.producersList = producers;
    this.producersListSearch = search;
  }

  public selectResult(sample, resultDu): void
  {
    if(!this.allSelected[sample.id]){
      if(this.cancellableDus.indexOf(resultDu.du.solutionCode)>-1){
        if (resultDu.inArray(this.selectedResults)) {
          resultDu.removeFromArray(this.selectedResults);
        } else {
          this.selectedResults.push(resultDu);
        }
      } else {
        //show error msg
        this.alertService.error("Ce résultat ne peut pas être annulé séparément, il sera uniquement annulé dans le cadre d’une demande d’annulation de tous les résultats de l’échantillon.")
      }
    }
  }

  public selectAll(sample): void
  {
    if(!this.allSelected[sample.id]) {
      for(let resultDu of sample.resultsDu) {
        if (!resultDu.calculationExcluded && !resultDu.du.solutionCode.includes("INH")) {
          this.selectedResults.push(resultDu);
        }
      }
      this.allSelected[sample.id] = true;
    } else {
      for(let resultDu of sample.resultsDu) {
        if (!resultDu.calculationExcluded) {
          resultDu.removeFromArray(this.selectedResults);
        }
      }
      this.allSelected[sample.id] = false;
    }
    console.log(this.selectedResults);
  }


  updateFilename(filename) {
    this.filename = filename;
  }

  updateUploadingFile(isUploading) {
    this.uploadingFile = isUploading;
  }

    atLeastOneResultInSample(sample: Sample) {
      for (let result of sample.resultsDu) {
          if (result.inArray(this.selectedResults)) {
              return true;
          }
      }
      return false;
    }

    /**
     * Get the path of access an uploaded file
     * @returns string|null
     */
    getFilePath() {
        if (this.filename) {
            return environment.uploadFolderUrl + this.filename;
        }
        return null;
    }

    public confirmCancellation(event: any): void
  {
    event.preventDefault();
    this.spinnerService.start("Envoi de la demande");
    let data = new Object();
    data['takingDate'] = this.takingDate.jsdate;
    data['producerSiret'] = this.selectedProducer.siret;
    data['results'] = this.selectedResults;
    data['comment'] = this.comment;
    data['filename'] = this.filename;
    this.cancellationService.cancelResults(data).then(
      function(code: any){
        this.orderCode = code;
        this.nextStep();
        this.clearAll();
        this.spinnerService.stop();
      }.bind(this),
      function(){
        this.spinnerService.stop();
      }.bind(this)
    );
  }

  /*********************/
  /*****  Storage  *****/
  /*********************/

  public saveAll(): void
  {
    let directory = "mylab_cancellation";
    this.localStorageService.save(directory, "takingDate", this.takingDate);
    this.localStorageService.save(directory, "selectedProducer", this.selectedProducer);
    this.localStorageService.save(directory, "producersList", this.producersList);
    this.localStorageService.save(directory, "producersListSearch", this.producersListSearch);
    this.localStorageService.save(directory, "allSelected", this.allSelected);
    this.localStorageService.save(directory, "selectedResults", this.selectedResults);
    this.localStorageService.save(directory, "comment", this.comment);
    this.localStorageService.save(directory, "filename", this.filename);
    this.localStorageService.save(directory, "samples", this.samples);
  }

  public loadAll(): void
  {
    let directory = "mylab_cancellation";
    let takingDate = this.localStorageService.get(directory, "takingDate", null);
    if(takingDate){
      this.takingDate = takingDate;
    }
    let selectedProducer = this.localStorageService.get(directory, "selectedProducer", "ThirdParty");
    if(selectedProducer){
      this.selectedProducer = selectedProducer;
    }
    const producersList = this.localStorageService.get(directory, "producersList", "ThirdParty");
    if (producersList){
        this.producersList = producersList;
    }
    const producersListSearch = this.localStorageService.get(directory, "producersListSearch", null);
    if (producersListSearch){
        this.producersListSearch = producersListSearch;
    }
    let allSelected = this.localStorageService.get(directory, "allSelected", null);
    if(allSelected){
      this.allSelected = allSelected;
    }
    let selectedResults = this.localStorageService.get(directory, "selectedResults", "ResultDu");
    if(selectedResults){
      this.selectedResults = selectedResults;
    }
    let comment = this.localStorageService.get(directory, "comment", null);
    if(comment){
      this.comment = comment;
    }
    let filename = this.localStorageService.get(directory, "filename", null);
    if(filename){
      this.filename = filename;
    }
    const samples = this.localStorageService.get(directory, "samples", "Sample");
    if (samples) {
      this.samples = samples;
    }
  }

  public clearAll(): void
  {
    this.localStorageService.clear('mylab_cancellation', null);
    let today = new Date;
    this.takingDate = { date: { year: today.getFullYear(), month: today.getMonth()+1, day: today.getDate() } };
    this.selectedProducer = null;
    this.allSelected = new Array();
    this.selectedResults = new Array();
    this.producersListSearch = null;
    this.producersList = [];
    this.comment = "";
    this.filename = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/cancellation/cancellation.component.ts